module.exports = __webpack_public_path__ + "static/01-d9a8117b91dae4afd4a33cb54d453de5.png";